import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { price: Number }
  static targets = ["qty", "total"]

  updateTotal() {
    const qty = parseFloat(this.qtyTarget.value) || 0
    const total = this.priceValue * qty
    this.totalTarget.textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)
  }
}
